import type { AuthData } from "./api"
import { useAuthStore } from "./stores/auth-store"

export function saveAuth(authData: AuthData, solicitudGuid: string): void {
  useAuthStore.getState().setAuth(authData, solicitudGuid)
}

export function getAuth(): { token: string; asegurado: AuthData["asegurado"]; solicitudGuid: string } | null {
  const state = useAuthStore.getState()

  if (!state.token || !state.asegurado || !state.solicitudGuid) return null

  return {
    token: state.token,
    asegurado: state.asegurado,
    solicitudGuid: state.solicitudGuid,
  }
}

export function clearAuth(): void {
  useAuthStore.getState().clearAuth()
}

export function isAuthenticated(): boolean {
  return useAuthStore.getState().checkAuth()
}
